"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _reactRouterDom = require("react-router-dom");
var _fastLink = _interopRequireDefault(require("./fast-link"));
var _leftMenu = _interopRequireDefault(require("./left-menu"));
var _allAppsMenu = _interopRequireDefault(require("../all-apps-menu/all-apps-menu"));
var _scrollbarsVertical = _interopRequireDefault(require("../scrollbars/scrollbars-vertical.js"));
var _ScrollableContainer = _interopRequireDefault(require("../scrollbars/ScrollableContainer.js"));
require("./navigation-drawer.css");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
/*
For the base is used Ant Design component:
https://ant.design/components/layout/#components-layout-demo-side


The class of #NavDrawer element
is toggled with onCollapse and
toggleAllAppsBtn functions.

It has 4 states:
- drawerStart (initial onLoad state)
- drawerMainMenu (Menu expanded)
- drawerAllAppsMenu (All Apps expanded)
- drawerCollapsed (Everything is collapsed)

Depending on what class has #Layout item
we define props to elements using CSS
*/
var NavigationDrawer = /*#__PURE__*/function (_React$Component) {
  _inherits(NavigationDrawer, _React$Component);
  var _super = _createSuper(NavigationDrawer);
  function NavigationDrawer(props) {
    var _this;
    _classCallCheck(this, NavigationDrawer);
    _this = _super.call(this, props);
    _this.state = {
      drawerState: "drawerStart",
      opened: true,
      title: _this.props.appTitle,
      titleClass: "SomeAppClass",
      collapsed: false,
      allApps: false
    };
    _this.apps = /*#__PURE__*/_react["default"].createElement(_allAppsMenu["default"], {
      allAppsItems: _this.props.allAppsItems
    });
    return _this;
  }
  _createClass(NavigationDrawer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props !== prevProps) {
        this.setState({
          title: this.props.appTitle
        });
      }
    }
  }, {
    key: "handleMenuClick",
    value: function handleMenuClick(e) {
      //    console.log("clicked: ", e, '\ne.path:',e.path);
      //  this.setState({ selectedItem: [e.path] });
    }

    // Collapsing of Navigation Drawer function
  }, {
    key: "onCollapse",
    value: function onCollapse(collapsed) {
      collapsed = !collapsed;
      this.props.adjustScrollWidth();
      this.setState({
        drawerState: collapsed ? "drawerCollapsed" : "drawerMainMenu",
        opened: !this.state.opened,
        titleClass: collapsed ? "hidden" : "SomeAppClass",
        collapsed: collapsed
      });
    }

    // Switching states of NavDrawer (mainMenu(expanded/collapsed)/all Apps menu) function
  }, {
    key: "toggleAllAppsBtn",
    value: function toggleAllAppsBtn() {
      this.setState({
        drawerState: this.state.drawerState !== "drawerAllAppsMenu" ? "drawerAllAppsMenu" : this.state.opened ? "drawerMainMenu" : window.innerWidth > 800 ? "drawerCollapsed" : "drawerMainMenu",
        title: this.state.drawerState !== "drawerAllAppsMenu" ? "Apps" : this.props.appTitle,
        titleClass: this.state.drawerState !== "drawerAllAppsMenu" ? "AllAppsClass" : "SomeAppClass",
        collapsed: !this.state.opened ? true : this.state.collapsed,
        opened: this.state.opened,
        allApps: !this.state.allApps
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var elem = document.getElementById("navigationDrawer");
      var visible = '';
      if (elem) {
        if (elem.classList.contains('visible')) visible = ' visible';
      }
      var avatar = this.props.userAvatar ? /*#__PURE__*/_react["default"].createElement("img", {
        src: this.props.userAvatar,
        style: {
          width: '32px',
          height: '32px',
          borderRadius: '32px'
        }
      }) : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "material-icons-round arrow",
        style: {
          fontSize: '32px',
          lineHeight: '32px',
          color: '#888'
        }
      }, "account_circle");
      var userBlock = this.props.userName && (typeof this.props.userAction === 'string' ? /*#__PURE__*/_react["default"].createElement(_fastLink["default"], {
        key: "userBlock",
        url: this.props.userAction
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "userBlock",
        key: "userBlock"
      }, avatar, /*#__PURE__*/_react["default"].createElement("span", {
        className: "UserName"
      }, this.props.userName))) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "userBlock",
        key: "userBlock",
        onClick: this.props.userAction
      }, avatar, /*#__PURE__*/_react["default"].createElement("span", {
        className: "UserName",
        onClick: this.props.userAction
      }, this.props.userName)));
      var menu = !this.props.hideAllAppsMenu && this.state.allApps ? /*#__PURE__*/_react["default"].createElement(_allAppsMenu["default"], {
        allAppsItems: this.props.allAppsItems,
        key: "allAppsItems"
      }) : /*#__PURE__*/_react["default"].createElement(_leftMenu["default"], {
        menuItems: this.props.menuItems,
        key: "menuItems",
        collapsed: this.state.collapsed,
        modal: this.props.modal
      }); /* Main Menu */
      var content = [menu, userBlock, /*#__PURE__*/_react["default"].createElement("div", {
        className: "logOutBlock",
        onClick: this.props.signOut,
        key: "logoutBlock"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: require('../../uiux/assets/images/sign-out-icon.svg'),
        style: {
          opacity: .5
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "label"
      }, "Sign out")), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          minHeight: '22px'
        },
        key: "bottomPadding"
      })];
      var collapseArrow = this.state.opened ? "keyboard_arrow_left" : "keyboard_arrow_right";
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "navigationDrawer",
        className: this.state.drawerState + visible
      }, /*#__PURE__*/_react["default"].createElement(_ScrollableContainer["default"], {
        vertical: true,
        backgroundColor: "white",
        containerClassName: "navigationDrawerContainer",
        scrollableClassName: "navigationDrawerItems"
      }, !this.props.hideAllAppsMenu ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "all-apps-btn",
        onClick: function onClick() {
          _this2.toggleAllAppsBtn();
        }
      }) : "", /*#__PURE__*/_react["default"].createElement("div", {
        className: "ScrollingBody"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "logo"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: require('../../uiux/assets/images/logo.svg')
      }), /*#__PURE__*/_react["default"].createElement("h2", {
        className: this.state.titleClass
      }, this.state.title)), content)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "collapseBar",
        onClick: function onClick() {
          return _this2.onCollapse(_this2.state.collapsed);
        }
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "material-icons-round arrow"
      }, collapseArrow)));
    }
  }]);
  return NavigationDrawer;
}(_react["default"].Component);
var _default = exports["default"] = NavigationDrawer;